import { AES, enc } from "crypto-js";
import __ from "lodash";
import { LOCAL_STORAGE_PREFIX, LOCAL_STORAGE_KEY, VERSION_KEY, LOCAL_STORAGE_KEYS } from "../constants/Constants";

const secretKey = LOCAL_STORAGE_KEY;
const prefix = LOCAL_STORAGE_PREFIX;
class StoreClass {
    get(key) {
        const item = localStorage.getItem(prefix + "." + key) && localStorage.getItem(prefix + "." + key).replaceAll('"', "");
        if (item && key !== VERSION_KEY && key !== LOCAL_STORAGE_KEYS.USER_TOKEN && key !== LOCAL_STORAGE_KEYS.REFRESH_TOKEN) {
            const value = AES.decrypt(item, secretKey).toString(enc.Utf8);
            return value ? JSON.parse(value) : value;
        } else {
            return item;
        }
    }

    set(key, value) {
        if (
            value !== null &&
            value !== undefined &&
            key !== VERSION_KEY &&
            key !== LOCAL_STORAGE_KEYS.USER_TOKEN &&
            key !== LOCAL_STORAGE_KEYS.REFRESH_TOKEN
        ) {
            localStorage.setItem(prefix + "." + key, AES.encrypt(JSON.stringify(value), secretKey).toString());
        } else {
            localStorage.setItem(prefix + "." + key, value);
        }
    }

    getSetLogin(value) {
        if (value) {
            //passed value, so set in local storage without prefix
            localStorage.setItem(LOCAL_STORAGE_KEYS.LOGGED_IN, value);
        } else {
            //no value passed
            localStorage.getItem(LOCAL_STORAGE_KEYS.LOGGED_IN);
        }
    }

    remove(key) {
        localStorage.removeItem(prefix + "." + key);
    }

    has(key) {
        return !__.isUndefined(this.get(key)) && !__.isNull(this.get(key));
    }

    clearAll() {
        localStorage.clear();
    }

    clearSessionStorage() {
        sessionStorage.clear();
    }

    getUserToken() {
        const configData = this.get(LOCAL_STORAGE_KEYS.CONFIG_DATA);
        return configData.USERTOKEN;
    }
}

export default new StoreClass();
